import { FC, useEffect } from "react";
import { useAppDispatch } from "../../app/hooks";
import { useAccount, useMsal } from "@azure/msal-react";
import { useSelector } from "react-redux";
import { RootState } from "../../app/store";
import Table from "react-bootstrap/Table";
import Button from "react-bootstrap/Button";
import { BrandDiscount } from "../../models/responses/brandDiscount";
import { Col, Row, Spinner } from "react-bootstrap";
import { Eye, Plus } from "react-bootstrap-icons";
import { useNavigate } from "react-router-dom";
import { ClientType } from "../../models/enums/clientTypeEnum";
import { getBrandDiscounts } from "../../app/services/brandDiscountService";

interface Props {}

const BrandDiscounts: FC<Props> = () => {
  const dispatch = useAppDispatch();
  const navigate = useNavigate();
  const { instance, accounts } = useMsal();
  const account = useAccount(accounts[0] || {});
  const brandDiscounts: BrandDiscount[] = useSelector(
    (state: RootState) => state.brandDiscount.brandDiscountList || []
  );
  const loadingBrandDiscounts = useSelector(
    (state: RootState) => state.brandDiscount.isWaitingBrandDiscountGetResponse
  );
  const clientType = useSelector(
    (state: RootState) => state.clientType.clientType
  );

  const clientTypeLabel =
    clientType === ClientType.Standard ? "Skadeverkstad" : "AD Butik";

  useEffect(() => {
    dispatch(getBrandDiscounts(instance, account));
  }, [account, accounts, dispatch, instance]);

  const openBrandDiscountHandler = (brandDiscount: BrandDiscount) => {
    navigate(`/brand-discounts/${brandDiscount.id}`, { relative: "path" });
  };

  return (
    <div>
      <Row className="mb-3">
        <Col>
          <h1>Rabatter</h1>
        </Col>
        <Col className="text-end">
          <Button
            className="mt-2 ms-2"
            variant="outline-primary"
            href={`/brand-discounts/add`}
          >
            Lägg till <Plus />
          </Button>
        </Col>
      </Row>

      <Table responsive striped bordered hover>
        <thead>
          <tr>
            <th>Bilmärke</th>
            <th>VSN %</th>
            <th>SPN %</th>
            <th></th>
          </tr>
        </thead>
        <tbody>
          {brandDiscounts.map((brandDiscount) => (
            <tr
              key={brandDiscount.id}
              role="button"
              onClick={() => openBrandDiscountHandler(brandDiscount)}
            >
              <td>{brandDiscount.carBrand?.name ?? ""}</td>
              <td>{brandDiscount.workshopSalesDiscount}{' %'}</td>
              <td>{brandDiscount.storeDiscount}{' %'}</td>              
              <td align="center">
                <Eye />
              </td>
            </tr>
          ))}
        </tbody>
      </Table>

      {loadingBrandDiscounts && (
        <>
          <Row className="mb-3">
            <Col className="text-center">
              <Spinner variant="primary" />
            </Col>
          </Row>
        </>
      )}
    </div>
  );
};

export default BrandDiscounts;
